module.exports = __webpack_public_path__ + "static/edit-homepage-carousel-9677f095a5b0c02ec2167d8a7a59cf49.png";